import React from 'react';
import PropTypes from 'prop-types';
import Image from '../Image/Image';
import Link from '../Link/Link';

// Utils
import truncateString from '../../utils/truncateString';
import generateCategoryColor from '../../utils/generateCategoryColor';

// Style
import './latest-articles.scss';

const LatestArticles = ({ posts }) => (
  <div className="latestArticlesWrapper">
    <h3 className="text-left">
      Latest <span className="text-normal">Articles</span>
    </h3>
    <div className="articles">
      {posts &&
        posts.length &&
        posts.slice(0, 5).map((data) => {
          const firstCategory = data?.categories?.edges?.length
            ? data.categories.edges.slice(0, 1).map(({ node }) => node.slug)
            : [];
          return (
            <Link key={data.id} className="article-link" href={`/blog${data.uri}`}>
              <div className="article-box flex flex-middle my-1">
                <div className="article-box-image">
                  <Image
                    img={data.featuredImage?.node?.mediaItemUrl}
                    alt={data.title}
                    radius={20}
                  />
                </div>
                <div className="article-box-content flex flex-column">
                  <a
                    href={`/blog/tags/${firstCategory}`}
                    className="article-box-content-tag text-uppercase text-bold"
                    style={{
                      color: generateCategoryColor(firstCategory.toString()),
                    }}
                  >
                    {firstCategory.toString().replace(/-/g, ' ')}
                  </a>
                  <p className="article-box-content-title text-bold">
                    {truncateString(data.title, 38)}
                  </p>
                </div>
              </div>
            </Link>
          );
        })}
    </div>
  </div>
);

LatestArticles.propTypes = {
  posts: PropTypes.array.isRequired, // eslint-disable-line
};

export default LatestArticles;
